module.exports = __webpack_public_path__ + "static/media/sony-mdr-7506.0bd2bbea.jpg";